"use client"

interface HorizontalStepsProps {
  steps: any[]
  activeStep: number
  setActiveStep: (step: number) => void
}

export default function HorizontalSteps({ steps, activeStep, setActiveStep }: HorizontalStepsProps) {
  return (
    <div className="flex gap-4 overflow-x-auto pb-4 px-4 pt-4">
      {steps?.map((step, index) => (
        <div
          key={index}
          onClick={() => setActiveStep(index)}
          className={`relative flex-shrink-0 w-64 p-4 bg-white rounded-lg shadow-md cursor-pointer transition-all ${
            activeStep === index ? "ring-2 ring-blue-500 scale-105" : "hover:shadow-lg"
          }`}
        >
          {step.requiresMarkers && (
            <div className="absolute top-2 right-2 text-xs text-blue-600 font-medium bg-blue-100 px-2 py-1 rounded-full">
              Markers
            </div>
          )}
          <div className="flex items-center gap-2 mb-2">
            <span className="text-2xl">{step.icon || "📄"}</span>
            <h3 className="font-bold text-sm">{step.title}</h3>
          </div>
          <div className="text-xs text-gray-500 mb-1">{step.phase || "Guide"}</div>
          <div className="text-xs italic text-blue-600">{step.example}</div>
          {step.hboi?.activities && (
            <div className="mt-2 flex flex-wrap gap-1">
              {step.hboi.activities.map((activity, idx) => (
                <span key={idx} className="px-2 py-1 rounded-full text-xs bg-gray-100 flex items-center gap-1">
                  {activity}
                </span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
